import baseHttpService from "core/http/singleton/base";

import {
  exportEmployeeRequestUrl,
  getEmployeeArriveLateRequestDetailUrl,
  getEmployeeArriveLateRequestUrl,
  getEmployeeFeedbackRequestDetailUrl,
  getEmployeeFeedbackRequestUrl,
  getEmployeeLeaveRequestDetailUrl,
  getEmployeeLeaveRequestUrl,
} from "./urls";
import { SCREEN } from "helper/roleChecker/Screens";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent";

const pathType = {
  [declareLeaveURL.leave]: "register-leave",
  [declareLeaveURL.lackOfTime]: "arrive-late",
  [declareLeaveURL.feedback]: "explain",
};

const screenCode = SCREEN.IP_023;

export const getEmployeeLeaveRequestApi = async (payload) => {
  const res = await baseHttpService.get(
    getEmployeeLeaveRequestUrl(screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getEmployeeArriveLateRequestApi = async (payload) => {
  const res = await baseHttpService.get(
    getEmployeeArriveLateRequestUrl(screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getEmployeeFeedbackRequestApi = async (payload) => {
  const res = await baseHttpService.get(
    getEmployeeFeedbackRequestUrl(screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getEmployeeArriveLateDetailApi = async (id) => {
  const res = await baseHttpService.get(
    getEmployeeArriveLateRequestDetailUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getEmployeeLeaveDetailByIdApi = async (id) => {
  const res = await baseHttpService.get(
    getEmployeeLeaveRequestDetailUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};
export const getEmployeeFeedbackDetailApi = async (id) => {
  const res = await baseHttpService.get(
    getEmployeeFeedbackRequestDetailUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const exportEmployeeRequestApi = async (params) => {
  const { type, ...rest } = params;
  const res = await baseHttpService.get(
    exportEmployeeRequestUrl(
      screenCode,
      pathType[type || declareLeaveURL.leave]
    ),
    rest,
    {
      responseType: "blob", // Ensure response is treated as a file
    }
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const updateLeaveMaternityOrderApi = async (screen, formData) => {
  const res = await baseHttpService.put(
    getEmployeeLeaveRequestUrl(screen),
    formData
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
